/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ubb.component.status.service.rpc.UbbComponentStatusServiceAppRpc
 */
import * as References from './UbbComponentStatusServiceAppRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.ubb.component.status.service.rpc.UbbComponentStatusServiceAppRpc#getComponentStatusForPortal
 */
export const GET_COMPONENT_STATUS_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_ubb_component_status_service_rpc_UbbComponentStatusServiceAppRpc_getComponentStatusForPortal';
export const GET_COMPONENT_STATUS_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMPONENT_STATUS_FOR_PORTAL_QUERY_FIELD_NAME,
  args: ['component'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getComponentStatusForPortalRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});